/**
 * Strapi `upload.files.id` is an integer. Floats (costs, tolerances, etc.) must never
 * be used in `/api/upload/files/:id` — Postgres rejects non-integer ids.
 */

export function isValidStrapiUploadFileId(value) {
  if (value == null || value === "") return false;
  if (typeof value === "number") {
    return Number.isInteger(value) && value > 0 && Number.isSafeInteger(value);
  }
  if (typeof value === "string") {
    const s = value.trim();
    if (!/^\d+$/.test(s)) return false;
    const n = Number(s);
    return Number.isInteger(n) && n > 0 && Number.isSafeInteger(n);
  }
  return false;
}

/** @returns {number|null} */
export function coerceStrapiUploadFileId(value) {
  if (!isValidStrapiUploadFileId(value)) return null;
  return typeof value === "number" ? value : Number(String(value).trim());
}

/** Resolve Strapi media relation / bare id to a numeric file id, or null. */
export function extractStrapiUploadFileId(ref) {
  if (ref == null) return null;
  if (isValidStrapiUploadFileId(ref)) return coerceStrapiUploadFileId(ref);
  if (typeof ref === "object") {
    if (isValidStrapiUploadFileId(ref.id)) return coerceStrapiUploadFileId(ref.id);
    if (isValidStrapiUploadFileId(ref.data?.id)) return coerceStrapiUploadFileId(ref.data.id);
    if (isValidStrapiUploadFileId(ref.attributes?.id))
      return coerceStrapiUploadFileId(ref.attributes.id);
  }
  return null;
}
